import useFetchIntegrationSettingsList from 'hooks/useFetchIntegrationSettingsList';
import {
  IntegrationCategory,
  IntegrationStatus,
  IntegrationType,
} from 'models/InternalIntegrationSetting';
import { IntegrationsBadgeFilter } from 'pages/integrations/IntegrationsTabs.constants';

const useFetchOthersChannels = () => {
  const { data, isLoading } = useFetchIntegrationSettingsList({
    type: IntegrationType.CHANNEL,
    category: IntegrationCategory.DIRECT_CHANNEL,
    badgeFilter: IntegrationsBadgeFilter.WITHOUT_BADGES,
  });

  const otherChannels = data?.data.filter(
    ({ agencySettings }) => agencySettings.status === IntegrationStatus.ACTIVE,
  );
  const isEmpty = !otherChannels?.length;

  return { isLoading, otherChannels, isEmpty };
};

export default useFetchOthersChannels;
